import React from 'react'
import Dialogs from '../costra/Dialogs.js'
import Translate from '../costra/Translate.js'

import DialogFrame from './DialogFrame.js'

import '../css/dialog.css'

function close() {
  Dialogs.close(null)
}

function DialogErrorPlaceholder(props) {
  return <DialogFrame>
    <div>
      {Translate.get(props.error)}
    </div>
    <div className="dialogControls">
      <div className="button right"
           onClick={close}>
        {Translate.get('close.button')}
      </div>
    </div>
  </DialogFrame>
}

export default DialogErrorPlaceholder